// extracted by mini-css-extract-plugin
export default {"root":"DJlYAH","checkbox":"vACq2r","checkboxError":"NwtAox"};